import {
    validationDefault,
    validationDefaultNew,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';
import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import requestsListStatus from './requestsListStatus';
import { randomFloat } from '../../components/utilities/functions/General';
import { objGenericUrl } from '../defaultConfigRole/genericUrls';
import { PROPERTIES, URL } from '../../constants/constantValues';
import requestsWarrantyList from './requestsWarrantyList';
import requestsFinancialSolutionsStatus from './requestsFinancialSolutionsStatus';

const Rules = {
    role_66db027cb55a420a99a954fd356183c7: {
        //Cartera
        home: 'credits',
        requestsListStatus,
        requestsWarrantyList,
        requestsFinancialSolutionsStatus,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['listRequestCredit'],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient', 'AutomaticFilters'],
                    },
                    {
                        name: 'Contacto solicitante',
                        component: ['ContactsClient'],
                    },
                    { name: 'Codeudores', component: ['CodebtorCredit'] },
                    {
                        name: 'Acta de aprobación',
                        component: [
                            'ApprovalCertificate',
                            // 'InformationCredit',
                            // 'CalculatorCredit',
                        ],
                    },
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                ],
                actionStatus: [
                    'rechazar',
                    'desistir',
                    'devolver',
                    'retornar',
                    'substatesRequest',
                ],
                actionStatusAll: ['resumen', 'anotaciones'],
                groupUser: 21,
            },
            createWarranty: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['listRequestCredit', 'viewWarrantyCount'],
                components: [
                    {
                        name: 'Cliente',
                        component: [
                            // 'InformationClient',
                            // 'ContactsClient',
                            // 'BusinessInformationCreditAlly',
                            'ClientCardsInfo',
                            'AutomaticFilters',
                        ],
                    },
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    { name: 'Documentos', component: ['DocumentsWarranty'] },
                    {
                        name: 'Inf. del Vehículo',
                        component: [
                            'InformationWarrantyVehicle',
                            'ContactsWarranty',
                        ],
                    },
                    {
                        name: 'Inf. garantía vehicular',
                        component: [
                            // 'InformationWarranty',
                            'BillsWarranty',
                            'FinancialEvaluationWarranty',
                        ],
                    },
                ],
                actionStatus: ['devolver', 'retornar'],
                actionStatusAll: ['anotaciones'],
                notEditForm: true,
            },
            createFinancialSolutions: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewFSGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    {
                        name: 'Solución financiera',
                        component: ['FinancialSolutions'],
                    },
                    {
                        name: 'Documentos',
                        component: ['DocumentsFinancialSolution'],
                    },
                ],
                actionStatus: [
                    'desistir',
                    'rechazar',
                    'devolver',
                    'anotaciones',
                    'enviar_creacion',
                    'retornar',
                ],
                actionStatusAll: ['anotaciones'],
                notEditForm: true,
            },
            consult: {
                permisions: ['consultClientList', 'ConsultClientEdit'],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: true,
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: ['informationClient:list'],
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: true,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        name: 'grupo_social',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.grupo_etnico,
                    },
                ],
            },
            socioeconomicClient: {
                permisions: [
                    'socioeconomicClient:list',
                    'socioeconomicClient:edit',
                ],
                fields: [
                    {
                        name: 'estado_civil',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.estado_civil,
                        validation: validationDefault(
                            ['required'],
                            'estado civil'
                        ),
                    },
                    {
                        name: 'tipo_vivienda',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.tipo_vivienda,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'tipo vivienda'
                        ),
                    },
                    {
                        name: 'estrato',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'max', value: PROPERTIES.STRATUM.max },
                                { type: 'min', value: PROPERTIES.STRATUM.min },
                            ],
                            'estrato'
                        ),
                    },
                    {
                        name: 'ciiu',
                        label: 'Actividad económica',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                        validation: validationDefault(
                            ['required'],
                            'Actividad económica'
                        ),
                    },
                    {
                        name: 'descripcion_actividad_economica',
                        label: 'Descripción actividad económica',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],
                            'descripción actividad económica'
                        ),
                    },
                    {
                        label: 'Antigüedad residencia (meses)',
                        name: 'antiguedad_residencia',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad residencia'
                        ),
                    },
                    {
                        name: 'tamano_hogar',
                        label: 'Integrantes del hogar',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.min,
                                },
                            ],
                            'Integrantes del hogar'
                        ),
                    },
                    {
                        name: 'personas_a_cargo',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                },
                            ],
                            'personas a cargo'
                        ),
                    },
                    {
                        name: 'numero_hijos',
                        label: 'Número hijos',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.min,
                                },
                            ],
                            'número de hijos'
                        ),
                    },
                    {
                        name: 'escolaridad',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.escolaridad,
                        validation: validationDefault(
                            ['required'],
                            'escolaridad'
                        ),
                    },
                    {
                        name: 'naturaleza',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        // validation: validationDefault(
                        //     ['required'],
                        //     'naturaleza'
                        // ),
                        options: [
                            {
                                value: 'I',
                                label: 'Independiente',
                                fields: [
                                    {
                                        name: 'tipo_de_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE.required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .minLength,
                                                },
                                            ],
                                            'tipo de negocio'
                                        ),
                                    },
                                    {
                                        name: 'nombre_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'nombre negocio'
                                        ),
                                    },
                                    {
                                        name: 'experiencia',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .minLength,
                                                },
                                            ],
                                            'experiencia'
                                        ),
                                    },
                                    {
                                        name: 'antiguedad',
                                        label: 'Antigüedad',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .min,
                                                },
                                            ],
                                            'antigüedad'
                                        ),
                                    },
                                    {
                                        name: 'actividad',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .minLength,
                                                },
                                            ],
                                            'actividad'
                                        ),
                                    },
                                    {
                                        label: 'Descripción',
                                        name: 'descripcion',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .DESCRIPTION.minLength,
                                                },
                                            ],
                                            'descripción'
                                        ),
                                    },
                                    {
                                        name: 'ingresos_aproximados',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'segundo apellido'
                                        ),
                                    },
                                    {
                                        name: 'sector_economico',
                                        label: 'Sector económico',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .minLength,
                                                },
                                            ],
                                            'sector económico'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_permanentes',
                                        label: 'Número de empleados permanentes',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.min,
                                                },
                                            ],
                                            'número de empleados permanentes'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_temporales',
                                        label: 'Número de empleados temporales',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.min,
                                                },
                                            ],
                                            'número de empleados temporales'
                                        ),
                                    },
                                    {
                                        name: 'tipo_local',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'tipo de local'
                                        ),
                                    },
                                ],
                            },
                            // {
                            // 	value: "E",
                            // 	label: "Empleado",
                            // 	fields: [{
                            // 			name: "nombre_empresa",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "ingresos",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "actividad_economica",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "cargo",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "antiguedad",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "tipo_contrato",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 	]
                            // },
                            // {
                            // 	value: "J",
                            // 	label: "Jubilado",
                            // 	fields: [{
                            // 			name: "nombre_empresa",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 		{
                            // 			name: "ingresos",
                            // 			disabled: false,
                            // 			type: "string",
                            // 			col: 2
                            // 		},
                            // 	]
                            // },
                        ],
                        isMulti: false,
                    },
                ],
            },
            contactsClient: {
                permisions: ['contactsClient:list'],
                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_contacto',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'ciudad de contacto'
                        ),
                    },
                    {
                        name: 'barrio_contacto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_contacto',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del contacto'
                        ),
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ADDRESS.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ADDRESS.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ADDRESS.minLength,
                                },
                            ],
                            'dirección'
                        ),
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'telefono',
                        label: 'Teléfono',
                        disabled: true,
                        type: 'phone',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono'
                        ),
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: true,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                    },
                    {
                        name: 'correo_electronico',
                        label: 'Correo electrónico',
                        disabled: true,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.EMAIL.required,
                                },
                            ],
                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'principal',
                        label: 'Principal',
                        disabled: true,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        col: 6,
                        showTable: true,
                    },
                ],
                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:edit',
                ],
                fields: [
                    {
                        name: 'estado_solicitud',
                        type: 'hidden',
                        col: 12,
                    },
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },
                    {
                        name: 'oficina',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: URL.OFICINAS.value,
                        validation: validationDefault(['required'], 'oficina'),
                    },
                    {
                        name: 'ejecutivo',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        //options: [],
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'ejecutivo'
                        ),
                    },
                    {
                        name: 'origen',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                        validation: validationDefault(['required'], 'origen'),
                    },
                    {
                        name: 'medio',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.MEDIO.value,
                        validation: validationDefault(['required'], 'medio'),
                    },
                    {
                        name: 'tipo_credito',
                        label: 'Tipo crédito',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_credito,
                        validation: validationDefault(
                            ['required'],
                            'tipo de crédito'
                        ),
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: true,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
                fieldsDynamic: [],
                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p10: [
                        // Prestamiga Renovacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p18: [
                        // Prestamiga Reactivacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p12: [
                        // Cultiva renovacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            label: 'Modelo vehículo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],
                                'modelo'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'valor_fasecolda',
                            disabled: false,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p41: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p42: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p43: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/users/?groups=11&is_active=true',
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },

                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p118: [
                        // carga pasajeros 2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p119: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },

                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                },
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                fields: [
                    {
                        name: 'tipo_documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        options: genericOptions.tipo_de_adjunto,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            documentsFinancialSolution: {
                permisions: [
                    'documentsFinancialSolution:list',
                    'documentsFinancialSolution:edit',
                ],
                accept: 'image/png, image/jpeg, image/jpg, application/pdf',
                fields: [
                    {
                        name: 'sf_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: `/globals/sf_tipo_documentos/?roles=21&tipo_soluciones={0}`,
                        reduxParams: ['financialSolution.tipo_sf_id'],
                        shouldSendRequestConstantly: true,
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationCredit: {
                permisions: ['observationCredit:list'],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            observationFinancialSolution: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],
                fields: [
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'textarea',
                        col: 12,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                    'calculatorCredit:notCalculate',
                ],
                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            codebtorCredit: {
                permission: ['codebtorCredit:list', 'codebtorCredit:edit'],
                fields: [],
            },
            codebtorInformation: {
                tittle: 'codeudor',
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo identificación'
                        ),
                    },
                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        name: 'tipo_relacion',
                        label: 'Tipo relación',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        value: 1,
                    },
                ],
                socioEconomicCodebtor: {
                    fields: [
                        {
                            name: 'estado_civil',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.estado_civil,
                            validation: validationDefault(
                                ['required'],
                                'estado civil'
                            ),
                        },
                        {
                            name: 'estrato',
                            disabled: false,
                            type: 'integer',
                            col: 2,
                        },
                        {
                            name: 'ciiu',
                            label: 'Actividad económica',
                            disabled: false,
                            type: 'autocomplete',
                            col: 3,
                            options: [],
                            url: URL.ACTIVIDAD_ECONOMICA.value,
                            validation: validationDefault(
                                ['required'],
                                'Actividad económica'
                            ),
                        },
                        {
                            name: 'descripcion_actividad_economica',
                            label: 'Descripción actividad económica',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'descripción actividad económica'
                            ),
                        },
                        {
                            name: 'antiguedad_residencia',
                            label: 'Antigüedad residencia (meses)',
                            disabled: false,
                            type: 'integer',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.ANTIQUITY.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.ANTIQUITY.min,
                                    },
                                ],
                                'antigüedad residencia'
                            ),
                        },
                        {
                            name: 'personas_a_cargo',
                            disabled: false,
                            type: 'integer',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                    },
                                ],
                                'personas a cargo'
                            ),
                        },
                        {
                            name: 'numero_hijos',
                            label: 'Número hijos',
                            disabled: false,
                            type: 'integer',
                            col: 4,

                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.NUMBER_OF_CHILDREN
                                            .max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.NUMBER_OF_CHILDREN
                                            .min,
                                    },
                                ],
                                'número de hijos'
                            ),
                        },
                        {
                            name: 'escolaridad',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            options: genericOptions.escolaridad,
                            validation: validationDefault(
                                ['required'],
                                'escolaridad'
                            ),
                        },
                        {
                            name: 'naturaleza_persona',
                            label: 'Naturaleza',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            validation: validationDefault(
                                ['required'],
                                'naturaleza'
                            ),
                            options: [
                                {
                                    value: 'I',
                                    label: 'INDEPENDIENTE',
                                    fields: [
                                        {
                                            name: 'tipo_de_negocio',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'nombre',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'experiencia',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'antiguedad',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'actividad',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'descripcion',
                                            label: 'Descripción',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'ingresos_aproximados',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'sector_economico',
                                            label: 'Sector económico',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'numero_de_empleados_permanentes',
                                            label: 'Número de empleados permanentes',
                                            disabled: false,
                                            type: 'string',
                                            col: 3,
                                        },
                                        {
                                            name: 'numero_de_empleados_temporales',
                                            label: 'Número de empleados temporales',
                                            disabled: false,
                                            type: 'string',
                                            col: 3,
                                        },
                                        {
                                            name: 'tipo_local',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                    ],
                                },
                                {
                                    value: 'E',
                                    label: 'EMPLEADO',
                                    fields: [
                                        {
                                            name: 'nombre_empresa',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'ingresos',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'actividad_economica',
                                            label: 'Actividad económica',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'cargo',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'antiguedad',
                                            label: 'Antigüedad',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'tipo_contrato',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                    ],
                                },
                                {
                                    value: 'J',
                                    label: 'JUBILADO',
                                    fields: [
                                        {
                                            name: 'nombre_empresa',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                        {
                                            name: 'ingresos',
                                            disabled: false,
                                            type: 'string',
                                            col: 2,
                                        },
                                    ],
                                },
                            ],
                            isMulti: false,
                        },
                    ],
                    fieldsConditional: {
                        pI: [
                            {
                                name: 'trabajo_nombre',
                                label: 'Nombre del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'nombre del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del negocio',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'negocio_liquidez',
                                label: 'Liquidez',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'liquidez'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad  (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad residencia'
                                ),
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                                validation: validationDefault(
                                    ['required'],
                                    'Actividad económica'
                                ),
                            },
                            {
                                name: 'negocio_descripcion',
                                label: 'Descripción actividad económica',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'descripción actividad económica'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del negocio',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección del negocio'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                        ],
                        pE: [
                            // EMPLEADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                        ],
                        pP: [
                            // PENSIONADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                        ],
                        pFR: [
                            // FINCA RAIZ
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [{ type: 'minLength', value: 3 }],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                        pFS: [
                            // FIRMA SOLIDARIA
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [{ type: 'minLength', value: 3 }],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                    },
                },
                contactCodebtor: {
                    fields: [
                        {
                            name: 'ciudad_contacto',
                            label: 'Ciudad',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 6,
                            showTable: true,
                            options: [],
                            parentDependency: true,
                            childrenDependency: 'barrio_contacto',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad de contacto'
                            ),
                        },
                        {
                            name: 'barrio_contacto',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            showTable: true,
                            dependency: 'ciudad_contacto',
                            options: [],
                            url: URL.BARRIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'barrio del contacto'
                            ),
                        },
                        {
                            name: 'direccion',
                            label: 'Dirección',
                            disabled: false,
                            type: 'addressComplement',
                            staticCol: 12,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'required',
                                        value: PROPERTIES.ADDRESS.required,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.ADDRESS.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.ADDRESS.minLength,
                                    },
                                ],
                                'dirección'
                            ),
                        },
                        {
                            name: 'referencia_ubicacion',
                            label: 'Referencia ubicación',
                            disabled: false,
                            type: 'string',
                            col: 6,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES
                                            .BUSINESS_LOCATION_REFERENCE
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES
                                            .BUSINESS_LOCATION_REFERENCE
                                            .maxLength,
                                    },
                                ],
                                'referencia ubicación'
                            ),
                        },
                        {
                            name: 'tipo_vivienda',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_vivienda,
                            validation: validationDefaultNew(
                                [{ type: 'required', value: true }],
                                'tipo vivienda'
                            ),
                        },
                        {
                            name: 'telefono',
                            label: 'Teléfono',
                            disabled: false,
                            type: 'phone',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                ],
                                'teléfono'
                            ),
                        },
                        {
                            name: 'referencia_ubicacion',
                            label: 'Referencia ubicación',
                            disabled: false,
                            type: 'string',
                            col: 6,
                            showTable: true,
                        },
                        {
                            name: 'celular',
                            label: 'Celular',
                            disabled: false,
                            type: 'celular',
                            col: 3,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.CELL_PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.CELL_PHONE.required,
                                    },
                                ],
                                'celular'
                            ),
                        },
                        {
                            name: 'principal',
                            label: 'Dirección principal',
                            disabled: false,
                            type: 'select',
                            options: genericOptions.direccion_principal,
                            col: 3,
                            showTable: true,
                        },
                        {
                            name: 'correo_electronico',
                            label: 'Correo electrónico',
                            disabled: false,
                            type: 'email',
                            col: 6,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.EMAIL.regExp,
                                        mesagge:
                                            'El correo electrónico ingresado no es válido',
                                    },
                                ],
                                'correo electrónico'
                            ),
                        },
                    ],
                },
                codebtorConyuge: {
                    fields: [
                        {
                            name: 'Información básica',
                            desc: '',
                            fields: [
                                {
                                    name: 'tipo_identificacion',
                                    label: 'Tipo identificación',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.tipo_de_documento,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo identificación'
                                    ),
                                },
                                {
                                    name: 'numero_identificacion',
                                    label: 'Número identificación',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ID_NUMBER
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .minLength,
                                            },
                                        ],
                                        'número de identificación'
                                    ),
                                },
                                {
                                    name: 'primer_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_NAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'primer nombre'
                                    ),
                                },
                                {
                                    name: 'segundo_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'primer_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .minLength,
                                            },
                                        ],
                                        'primer apellido'
                                    ),
                                },
                                {
                                    name: 'segundo_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .minLength,
                                            },
                                        ],
                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'genero',
                                    label: 'Género',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.genero,
                                    validation: validationDefault(
                                        ['required'],
                                        'genero'
                                    ),
                                },
                                {
                                    name: 'lugar_nacimiento',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'lugar de nacimiento'
                                    ),
                                },
                                {
                                    name: 'fecha_nacimiento',
                                    disabled: false,
                                    type: 'date',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'fecha de nacimiento'
                                    ),
                                },
                                {
                                    name: 'tipo_relacion',
                                    label: 'Tipo relación',
                                    disabled: false,
                                    type: 'hidden',
                                    col: 3,
                                    value: 2,
                                },
                            ],
                            defaultValues: {
                                tipo_de_documento: 'CC',
                                numero_identificacion: Math.floor(
                                    randomFloat(0, 1) * 10000
                                ),
                                primer_nombre: 'test 1',
                                segundo_nombre: 'test 2',
                                primer_apellido: 'test ape1',
                                segundo_apellido: 'test ape2',
                                genero: 'H',
                                lugar_expedicion_documento: 1205,
                                fecha_expedicion_documento: '2020-08-30',
                                lugar_nacimiento: 1205,
                                fecha_nacimiento: '2020-08-30',
                                telefono: '3102344556',
                                //info-trabajo
                                estado_civil: 'S',
                                estrato: 1,
                                ciuu: 10,
                                descripcion_actividad_economica:
                                    'test information',
                                antiguedad_residencia: 1,
                                personas_a_cargo: 1,
                                numero_hijos: 1,
                                escolaridad: 'PO',
                                naturaleza: 'I',
                            },
                        },
                        {
                            name: 'Información de contacto',
                            desc: '',
                            fields: [
                                {
                                    name: 'ciudad_contacto',
                                    label: 'Ciudad',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 6,
                                    showTable: true,
                                    options: [],
                                    parentDependency: true,
                                    childrenDependency: 'barrio_contacto',
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad de contacto'
                                    ),
                                },
                                {
                                    name: 'barrio_contacto',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    showTable: true,
                                    dependency: 'ciudad_contacto',
                                    options: [],
                                    url: URL.BARRIOS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'barrio de contacto'
                                    ),
                                },
                                {
                                    name: 'direccion',
                                    label: 'Dirección',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ADDRESS
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ADDRESS
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ADDRESS
                                                    .minLength,
                                            },
                                        ],
                                        'dirección'
                                    ),
                                },
                                {
                                    name: 'referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    showTable: true,
                                },
                                {
                                    name: 'telefono',
                                    label: 'Teléfono',
                                    disabled: false,
                                    type: 'phone',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono'
                                    ),
                                },
                                {
                                    name: 'celular',
                                    label: 'Celular',
                                    disabled: false,
                                    type: 'celular',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.CELL_PHONE
                                                    .regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.CELL_PHONE
                                                    .required,
                                            },
                                        ],
                                        'celular'
                                    ),
                                },
                                {
                                    name: 'correo_electronico',
                                    label: 'Correo electrónico',
                                    disabled: false,
                                    type: 'email',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.EMAIL.regExp,
                                                mesagge:
                                                    'El correo electrónico ingresado no es válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.EMAIL
                                                    .required,
                                            },
                                        ],
                                        'correo electrónico'
                                    ),
                                },
                            ],
                        },
                        {
                            name: 'Información del trabajo',
                            desc: '',
                            fields: [
                                {
                                    name: 'trabajo_nombre',
                                    label: 'Empresa',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'empresa'
                                    ),
                                },
                                {
                                    name: 'trabajo_antiguedad',
                                    label: 'Antigüedad (meses)',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'max',
                                                value: PROPERTIES.ANTIQUITY.max,
                                            },
                                            {
                                                type: 'min',
                                                value: PROPERTIES.ANTIQUITY.min,
                                            },
                                        ],
                                        'antigüedad (meses)'
                                    ),
                                },
                                {
                                    name: 'trabajo_telefono',
                                    label: 'Teléfono de la empresa',
                                    disabled: false,
                                    type: 'phone',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono de la empresa'
                                    ),
                                },
                                {
                                    name: 'empresa_salario',
                                    label: 'Ingresos mensuales',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],
                                        'ingresos'
                                    ),
                                },
                                {
                                    name: 'otros_ingresos',
                                    label: 'Otros ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],
                                        'Otros ingresos'
                                    ),
                                },
                                {
                                    name: 'descripcion_otros_ingresos',
                                    label: 'Descripción otros ingresos',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .DESCRIPTION_ACTIVITY
                                                    .maxLength,
                                            },
                                        ],
                                        'descripción actividad económica'
                                    ),
                                },
                                {
                                    name: 'negocio_actividad',
                                    label: 'Actividad económica',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 6,
                                    options: [],
                                    url: URL.ACTIVIDAD_ECONOMICA.value,
                                },
                                {
                                    name: 'trabajo_ciudad',
                                    label: 'Ciudad de trabajo',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    parentDependency: true,
                                    childrenDependency: 'trabajo_barrio',
                                    col: 6,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'trabajo_barrio',
                                    label: 'Barrio del trabajo',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    dependency: 'trabajo_ciudad',
                                    trueDependency: 'ciudad',
                                    url: URL.BARRIOS.value,
                                },
                                {
                                    name: 'trabajo_direccion',
                                    label: 'Dirección del trabajo',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                },
                                {
                                    name: 'trabajo_referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .minLength,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .maxLength,
                                            },
                                        ],
                                        'referencia ubicación'
                                    ),
                                },
                            ],
                        },
                    ],
                },
            },
            heritageCodebtor: {
                fields: [
                    {
                        name: 'Presupuesto familiar',
                        desc: '...',
                        fields: [
                            {
                                name: 'ingreso_principal',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'ingreso principal'
                                ),
                            },
                            {
                                name: 'ingreso_conyuge',
                                label: 'Ingresos cónyuge',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'Ingresos cónyuge'
                                ),
                            },
                            {
                                name: 'otros_ingresos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'otros ingresos'
                                ),
                            },
                            {
                                name: 'gastos_familiar',
                                label: 'Gasto familiar',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'gasto familiar'
                                ),
                            },
                            {
                                name: 'obligaciones',
                                label: 'Obligaciones / cuotas',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'obligaciones / cuotas'
                                ),
                            },
                            {
                                name: 'excedente',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'excedente'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Presupuesto empresarial',
                        desc: '...',
                        fields: [
                            {
                                name: 'total_activos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total activos'
                                ),
                            },
                            {
                                name: 'total_pasivos',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total pasivo'
                                ),
                            },
                            {
                                name: 'total_patrimonio',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total patrimonio'
                                ),
                            },
                        ],
                    },
                ],
                realState: [
                    {
                        name: 'Bienes raíces',
                        desc: '...',
                        fields: [
                            {
                                name: 'tipo_vivienda',
                                label: 'Tipo de bien raíz',
                                disabled: false,
                                type: 'select',
                                options: genericOptions.tipo_de_bien_raiz,
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo de bien raíz'
                                ),
                            },
                            {
                                name: 'valor_bien_raiz',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                            },
                            {
                                name: 'direccion_bien_raiz',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        { type: 'maxLength', value: 255 },
                                        { type: 'minLength', value: 2 },
                                    ],
                                    'dirección'
                                ),
                            },
                        ],
                    },
                ],
                ownVehicle: [
                    {
                        name: 'Vehículo',
                        desc: '...',
                        fields: [
                            {
                                name: 'marca',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                url: URL.MARCAS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'marca'
                                ),
                            },
                            {
                                name: 'placa',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .minLength,
                                        },
                                        {
                                            type: 'pattern',
                                            value: /^[a-zA-Z0-9_.-]*$/,
                                            mesagge:
                                                'La placa solo debe tener numeros y letras',
                                        },
                                    ],
                                    'placa'
                                ),
                            },
                            {
                                name: 'modelo',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .minLength,
                                        },
                                    ],
                                    'modelo'
                                ),
                            },
                            {
                                name: 'valor_vehiculo',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                            },
                        ],
                    },
                ],
            },
            approvalCertificate: {
                permission: [
                    'list:approvalCertificate',
                    'edit:approvalCertificate',
                ],
                fields: [
                    {
                        name: 'vinculo_agro',
                        label: 'Vínculo agro',
                        disabled: true,
                        type: 'select',
                        options: genericOptions.vinculo_agro,
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'Vínculo agro'
                        ),
                    },

                    {
                        name: 'periodo_gracia',
                        disabled: false,
                        type: 'switch',
                        col: 4,
                        typeColumn: 2,
                        validation: validationDefault(
                            ['required'],
                            'periodo de gracia'
                        ),
                    },
                    {
                        name: 'meses_periodo',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_de_gracia,
                    },
                    {
                        name: 'excepcion',
                        label: 'Excepción',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: URL.TIPO_EXEPCIONES.value,
                    },
                    {
                        name: 'propuesta_inicial',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.propuesta_inicial,
                    },
                    {
                        name: 'codeudores',
                        disabled: false,
                        type: 'select-multiple',
                        col: 12,
                        url: objGenericUrl.personaSolicitud,
                        reduxParams: [
                            'client.numero_identificacion',
                            'credit.id',
                        ],
                    },
                    {
                        name: 'recoge_saldo',
                        disabled: false,
                        type: 'switch',
                        typeColumn: 2,
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'recoger saldo'
                        ),
                    },
                ],
                fieldsNoApproved: [
                    {
                        name: 'causal',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.causal_no_aprobado,
                        validation: validationDefault(
                            ['required'],
                            'causal no aprobado'
                        ),
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=21',
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo reporte es obligatorio',
                            },
                        },
                        notSearchGlobals: true,
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'estados',
                        label: 'Estados',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/sf_estados/',
                    },
                ],
            },
            reportThirds: {
                fields: [
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                ],
            },
            informationClientException: {
                permissions: [],
                fields: [],
            },

            documentsWarranty: {
                permisions: [
                    'documentsWarranty:list',
                    'documentsWarranty:edit',
                ],
                disabledButtonSave: true,
                fields: [
                    {
                        name: 'tipo_documento',
                        disabled: true,
                        type: 'select',
                        col: 5,
                        url: '/globals/gmv_tipo_documentos/?roles=21&is_active=true&tramite_voluntario={0}&estado={1}',
                        reduxParams: [
                            'warranty.tramite_voluntario_String',
                            'warranty.estado.value',
                        ],
                        options: [],
                        showTable: true,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'documento',
                        disabled: true,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationWarranty: {
                permisions: ['observationWarranty:list'],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            InformationWarrantyVehicle: {
                permisions: ['InformationWarrantyVehicle:list'],
                fieldsUbicacion: [
                    {
                        name: 'ciudad_ubicacion',
                        label: 'Ciudad',
                        disabled: true,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_ubicacion',
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio_ubicacion',
                        label: 'Barrio ubicación',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_ubicacion',
                        trueDependency: 'ciudad',
                        notSearchGlobals: true,
                        url: URL.BARRIOS.value,
                    },
                    {
                        name: 'direccion_ubicacion',
                        label: 'Dirección',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
                fieldsEstado: [
                    {
                        name: 'peritaje',
                        label: 'Peritaje',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'kilometraje',
                        label: 'Kilometraje',
                        disabled: true,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'gps',
                        label: 'GPS',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'tipo_propietarios_vehiculo',
                        label: 'Propietario vehículo',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        url: `/globals/gmv_tipo_propietarios_vehiculos/?is_active=true`,
                    },
                    {
                        name: 'valor_fasecolda_vehiculo',
                        label: 'Valor fasecolda',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'Valor fasecolda'
                        ),
                    },
                    {
                        name: 'valor_peritaje_vehiculo',
                        label: 'Valor peritaje',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor peritaje'
                        ),
                    },
                ],
            },
            ContactsWarranty: {
                permisions: ['ContactsWarranty:list'],
                fields: [
                    {
                        name: 'nombre',
                        label: 'Nombre',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(['required'], 'nombre'),
                    },
                    {
                        name: 'celular',
                        label: 'Número telefónico',
                        disabled: true,
                        showTable: true,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                    {
                        name: 'tipo',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'ENCARGADO', label: 'ENCARGADO' },
                            { value: 'OTRO', label: 'OTRO' },
                        ],
                        validation: validationDefault(['required'], 'tipo'),
                    },
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
            },
            FinancialEvaluationWarranty: {
                permisions: [
                    'FinancialEvaluationWarranty:list',
                    'FinancialEvaluationWarranty:edit',
                ],
                fields: [
                    {
                        name: 'valor_acuerdo_venta_vehiculo',
                        label: 'Valor acuerdo venta',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor acuerdo'
                        ),
                    },
                    {
                        name: 'gastos_vehiculo',
                        label: 'Gastos vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Gastos vehiculo'
                        ),
                    },
                    {
                        name: 'valor_venta_vehiculo',
                        label: 'Valor venta vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor venta vehículo'
                        ),
                    },
                ],
                fieldsWarranty: [
                    {
                        name: 'tipo_venta',
                        label: 'Tipo de venta',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: [
                            { value: 'VENTA_DIRECTA', label: 'VENTA DIRECTA' },
                            { value: 'SUBROGACION', label: 'SUBROGACION' },
                        ],
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'tipo venta'
                        ),
                    },
                ],
            },
            filterDataTableWarranty: {
                permisions: ['filterDataTableWarranty'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                        notSearchGlobals: true,
                    },
                    {
                        name: 'productos',
                        label: 'Productos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        //options: [],
                        url: '/globals/productos/?id=4,6,1',
                        notSearchGlobals: true,
                    },
                ],
            },
            filterDataTableFinancialSolutions: {
                permisions: ['filterDataTableFinancialSolutions'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        //options: [],
                        url: '/globals/subproducto/',
                        notSearchGlobals: true,
                    },
                    {
                        name: 'tipo_solucion_financiera',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/sf_tipo_soluciones_financieras/ ',
                        notSearchGlobals: true,
                    },
                ],
            },
            BillsWarranty: {
                permisions: ['BillsWarranty:list'],
                fields: [
                    {
                        name: 'tipo_gasto',
                        label: 'Tipo gasto',
                        disabled: true,
                        type: 'select',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        url: '/globals/tipo_gastos_gmv/',
                        validation: validationDefault(
                            ['required'],
                            'Tipo gasto'
                        ),
                    },

                    {
                        name: 'valor',
                        label: 'Valor',
                        disabled: true,
                        type: 'price',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Valor'),
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: true,
                        type: 'string',
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                    },
                    {
                        name: 'documento',
                        label: 'Factura',
                        disabled: true,
                        type: 'file',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Factura'),
                    },
                ],
            },
            reportPayments: {
                permisions: ['reportPayments:list'],
                fields: [
                    {
                        name: 'pasarela',
                        label: 'Pasarela',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/pasarelas_pago/',
                        validation: validationDefault(['required'], 'pasarela'),
                    },
                    {
                        name: 'archivo',
                        label: 'Reporte',
                        disabled: false,
                        type: 'file',
                        col: 4,
                        validation: validationDefault(['required'], 'reporte'),
                    },
                ],
            },
            FinanceSolutionMassive: {
                fields: [
                    {
                        name: 'archivo',
                        label: 'Documento',
                        disabled: false,
                        type: 'file',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message:
                                    'El archivo para el envio de mensajes es obligatorio',
                            },
                        },
                    },
                ],
            },
        },
    },
};

export default Rules;
